<template>
  <div>
    <v-container class="pt-10">
      <v-card class="py-8 px-8 mb-12">
        <v-row>
          <v-col md="4">
            <v-row align="center" class="px-1">
              <v-col cols="3" md="3" sm="2" xs="2">
                <div>
                  <v-img
                    height="60px"
                    width="60px"
                    class="object-cover rounded"
                    :src="itemProduk.image3"
                  ></v-img>
                </div>
              </v-col>
              <v-col cols="9" md="9" sm="4" xs="2">
                <div class="d-flex flex-column">
                  <span class="text-subtitle-1 grey--text">CV. Muda Mulia</span>
                  <div>
                    <v-icon small color="amber darken-2">mdi-map-marker</v-icon
                    ><span class="ml-1 grey--text text-caption"
                      >Jakarta Utara</span
                    >
                  </div>
                </div>
              </v-col>
            </v-row>
            <div class="d-flex flex-column px-1 mt-6">
              <span class="text-subtitle-1 font-weight-bold"
                >Alamat Vendor</span
              >
              <span class="text-caption grey--text mt-1"
                >Jalan Hasanudin Gang Johor no 17, Kepatihan</span
              >
              <span class="text-caption grey--text">Kecamatan Joyoboyo</span>
              <span class="text-caption grey--text"
                >Kabupaten Kotawaringin Barat</span
              >
            </div>
          </v-col>
          <v-col md="4">
            <v-btn
              class="rounded custom-btn-outline text-caption px-6"
              min-height="40px"
              outlined
              color="amber darken-2"
            >
              chat +62875745654767
              <v-icon color="green" class="ml-2">mdi-whatsapp</v-icon></v-btn
            >
            <div class="d-flex flex-column px-1 mt-6">
              <span class="text-subtitle-1 font-weight-bold"
                >Informasi Tambahan</span
              >
              <span class="text-caption grey--text mt-1">SK. PT atau CV</span>
              <span class="text-caption grey--text">NIB</span>
            </div>
          </v-col>
          <v-col md="4"> </v-col>
        </v-row>
      </v-card>
      <BerandaVendorCarouselBanner></BerandaVendorCarouselBanner>
      <v-row :no-gutters="false" class="mt-12 mb-4">
        <v-col cols="4" md="3" class="pl-3 pr-1">
          <v-autocomplete
            v-model="value"
            :items="items"
            hide-details
            solo
            label="Cv. Muda Mulia"
          ></v-autocomplete>
        </v-col>
        <v-col cols="6" md="8" class="px-1">
          <v-text-field
            v-on:keyup.enter="searchOnEnter"
            v-on:blur="searchOnEnter"
            append-icon="mdi-magnify"
            placeholder="Kode, Deskripsi (press ENTER to search)"
            label="Search"
            hide-details
            solo
          ></v-text-field>
        </v-col>
        <v-col cols="1" md="1" class="pt-4">
          <v-btn @click="showFilterDialog" icon fab color="grey" small>
            <v-icon>mdi-filter</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-expand-transition>
        <v-card
          class="elevation-2 px-1 py-1 mt-3 mb-6"
          v-show="showFilter === true"
        >
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="4" md="4">
                <v-autocomplete
                  v-model="filterFdivisions"
                  :items="itemsFDivision"
                  item-value="id"
                  item-text="description"
                  dense
                  chips
                  small-chips
                  deletable-chips
                  clearable
                  label="kategori1"
                  multiple
                  hide-details
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="4" md="4">
                <v-autocomplete
                  v-model="filterFtopik"
                  :items="itemsFTopik"
                  item-value="id"
                  item-text="description"
                  dense
                  chips
                  small-chips
                  deletable-chips
                  clearable
                  label="kategori2"
                  multiple
                  hide-details
                ></v-autocomplete>
              </v-col>
              <v-col cols="6" sm="2" md="2">
                <v-btn color="primary" small @click="runExtendedFilter">
                  Terapkan
                  <v-icon small class="ml-1" color="green lighten-2"
                    >mdi-filter</v-icon
                  >
                </v-btn>
              </v-col>
            </v-row>

            <v-row> </v-row>
          </v-card-text>
        </v-card>
      </v-expand-transition>
      <v-row>
        <v-col md="2">
          <v-card class="py-4 px-4">
            <span class="text-h6 px-4">Kategori (3)</span>
            <v-navigation-drawer
              permanent
              v-model="drawer"
              :mini-variant.sync="mini"
            >
              <v-list>
                <v-list-item v-for="(navDrawer, i) in navDrawers" :key="i" link>
                  <template>
                    <v-list-item-content>
                      <v-list-item-title class="body-2">
                        {{ navDrawer.title }} ({{
                          navDrawer.jumlah
                        }})</v-list-item-title
                      >
                    </v-list-item-content>
                  </template>
                </v-list-item>
              </v-list>
            </v-navigation-drawer>
          </v-card>
        </v-col>
        <v-col md="9">
          <span class="text-h5 font-weight-medium">Produk</span>
          <v-layout wrap justify-center class="d-flex mt-2">
            <div v-for="(item, i) in cardItems" :key="i">
              <v-hover>
                <template v-slot:default="{ hover }">
                  <v-card
                    route
                    :to="
                      '/public-detail-produk/' + linkNeated(item.id.toString())
                    "
                    max-width="335"
                    xs12
                    sm4
                    px-3
                    class="ma-3 rounded-lg pb-6"
                    :elevation="hover ? 16 : 3"
                  >
                    <div>
                      <v-hover>
                        <template v-slot:default="{ hover }">
                          <v-img
                            height="250"
                            :src="item.image"
                            :class="{ 'hover-image': hover }"
                            class="rounded-lg"
                          ></v-img>
                        </template>
                      </v-hover>
                    </div>
                    <v-card-title class="text-caption mt-2"
                      >Produk Terbaru</v-card-title
                    >
                    <v-card-text>
                      <div>
                        {{ item.description }}
                      </div>
                      <div class="text-h6 mt-3">
                        Rp {{ item.price }}
                        <span class="text-subtitle-2">/ {{ item.satuan }}</span>
                      </div>
                      <v-row align="center" class="px-2 my-2">
                        <v-chip class="text-caption mr-3 red lighten-2" dark
                          >Disc {{ item.discount }}%</v-chip
                        >
                        <span>Rp 30000</span>
                      </v-row>
                    </v-card-text>
                    <v-card-text>
                      <v-row align="center" class="px-2">
                        <v-icon>mdi-map-marker</v-icon
                        ><span class="ml-2">{{ item.region }}</span>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </template>
              </v-hover>
            </div>
          </v-layout>
          <v-row class="my-10" justify="center" align="center">
            <v-col cols="10" md="9" sm="8" align="right">
              <v-pagination
                color="amber darken-2"
                v-model="currentPage"
                :length="totalPaginationPages"
              ></v-pagination>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <AppFooter v-if="false"></AppFooter>
  </div>
</template>
  
<script>
import BerandaVendorCarouselBanner from "./BerandaVendorCarouselBanner";
import AppFooter from "@/components/AppFooter.vue";
export default {
  name: "HomePublic",
  components: {
    AppFooter,
    BerandaVendorCarouselBanner,
  },
  data() {
    return {
      currentPage: 1,
      totalPaginationPages: 1,
      navDrawers: [
        { id: 1, title: "Excavator", jumlah: 10 },
        { id: 2, title: "Bulldozer", jumlah: 5 },
        { id: 3, title: "Material", jumlah: 7 },
      ],
      drawer: true,
      mini: false,
      cardItems: [
        {
          id: 1,
          image: "../assets/img_sample/dummy1.png",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Illo, repudiandae?",
          price: 30000,
          discount: 30,
          region: "Jakarta Utara",
          satuan: "bulan",
        },
        {
          id: 2,
          image: "../assets/img_sample/dummy2.png",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Illo, repudiandae?",
          price: 50000,
          discount: 30,
          region: "Jakarta Barat",
          satuan: "kg",
        },
        {
          id: 3,
          image: "../assets/img_sample/dummy2.png",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Illo, repudiandae?",
          price: 50000,
          discount: 30,
          region: "Jakarta Barat",
          satuan: "kg",
        },
        {
          id: 4,
          image: "../assets/img_sample/dummy2.png",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Illo, repudiandae?",
          price: 50000,
          discount: 30,
          region: "Jakarta Barat",
          satuan: "kg",
        },
        {
          id: 5,
          image: "../assets/img_sample/dummy2.png",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Illo, repudiandae?",
          price: 50000,
          discount: 30,
          region: "Jakarta Barat",
          satuan: "kg",
        },
        {
          id: 6,
          image: "../assets/img_sample/dummy2.png",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Illo, repudiandae?",
          price: 50000,
          discount: 30,
          region: "Jakarta Barat",
          satuan: "kg",
        },
        {
          id: 7,
          image: "../assets/img_sample/dummy2.png",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Illo, repudiandae?",
          price: 50000,
          discount: 30,
          region: "Jakarta Barat",
          satuan: "kg",
        },
      ],
      itemProduk: {
        id: 1,
        image1: "../assets/img_sample/dummy1.png",
        image2: "../assets/img_sample/dummy2.png",
        image3: "../assets/img_sample/dummy1.png",
        image4: "../assets/img_sample/dummy2.png",
        kode1:
          "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Modi, unde? Ut recusandae minima corporis laudantium cumque dolore. Aperiam, corrupti minima!",
        description:
          "Lorem ipsum dolor sit amet consectetur adipisicing elit. Deleniti repellendus quibusdam quod neque nostrum obcaecati, laborum totam placeat minima corporis ratione, magni, itaque distinctio. Sint tempora omnis dicta? Animi quo quos explicabo quibusdam, voluptatibus iste aut inventore magnam possimus labore excepturi, cumque exercitationem quidem itaque. Quod tempore minima, esse quisquam architecto non quibusdam sit suscipit deserunt corrupti odit voluptas beatae, similique veniam. Nobis eligendi maiores, magni quos quia officiis repudiandae labore expedita laboriosam nisi ipsa sapiente ad molestiae amet consequuntur cum, autem dolore eaque exercitationem dolor nulla quidem illo! Quam voluptatum possimus molestiae consequatur fuga officia dicta veritatis! Nam, voluptatibus.",
        price: 30000,
        discount: 30,
        region: "Jakarta Utara",
        satuan: "bulan",
      },
      items: ["foo", "bar", "fizz", "buzz"],
      value: null,
      showFilter: false,
    };
  },
  methods: {
    linkNeated(link) {
      return link.replace(/\s+/g, "-").toLocaleLowerCase();
    },
    searchOnEnter(event) {
      if (this.search !== event.target.value) {
        //Krusial untuk search
        // console.log(`${event.target.value} vs ${this.search}`)
        this.currentPage = 1;
        this.search = event.target.value;
        this.fetchFPeserta();
      }
    },
    showFilterDialog() {
      this.showFilter = !this.showFilter;
    },
  },
};
</script>
  
  <style>
</style>
  